<p-multiselect
  [options]="options()"
  [placeholder]="placeholder()"
  [maxSelectedLabels]="maxSelectedLabels()"
  [disabled]="disabled()"
  [(ngModel)]="value"
  (onPanelShow)="onPanelShow()"
  (onPanelHide)="onPanelHide()"
  styleClass="pssr-multiselect"
  class="pssr-multiselect">
  <ng-template #filter>
    <div class="pssr-form-checkbox-control select-all__checkbox-control">
      <p-checkbox
        [ngModel]="isAllSelected()"
        [binary]="true"
        (onChange)="selectAll()"
        class="pssr-checkbox" />
      <label class="pssr-checkbox-label">
        {{ 'app.forms.selectAll' | translate }}
      </label>
    </div>
  </ng-template>

  <ng-template #dropdownicon>
    <i
      [ngClass]="dropdownIcon()"
      class="pi"></i>
  </ng-template>
</p-multiselect>
